import styled from 'styled-components';
import { ApCheckbox, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
`;

export const OptionsWrapper = styled.div`
	margin-left: auto;
	display: flex;
	align-items: center;
`;

export const Divider = styled.div`
	width: 1px;
	height: 24px;
	margin: 0 7px;
	background-color: ${colors.grey3};
`;

export const CheckboxWrapper = styled.div`
	padding: 1px 6px 0 15px;

	span + span {
		text-transform: uppercase;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		letter-spacing: 0.8px;
		text-transform: uppercase;
		color: ${({ disabled }) =>
			disabled ? `${colors.grey5}` : `${colors.grey8}`};
		padding-left: 16px !important;
		cursor: ${({ disabled }) => (disabled ? `not-allowed` : `pointer`)};
	}
`;

export const StyledCheckbox = styled(ApCheckbox)`
	min-width: 18px;
`;

export const SpendWrapper = styled.div`
	max-width: 580px;
	display: flex;
	align-items: center;
	width: 330px;
`;

export const RangeWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 0 16px;

	.rc-slider {
		.rc-slider-track {
			background-color: ${colors.green1};
		}

		.rc-slider-handle {
			background-color: ${colors.green1};
			border-color: ${colors.green1};
			opacity: 1;
			width: 16px;
			height: 16px;
			margin-top: -6px;

			&:focus {
				box-shadow: 0 0 0 3px rgb(92, 179, 53, 0.4);
				border-color: ${colors.green1};
			}

			&.rc-slider-handle-dragging {
				box-shadow: 0 0 0 6px rgb(92, 179, 53, 0.4);
			}
		}
	}
`;

export const InputWrapper = styled.div`
	width: 100px;
	min-width: 100px;

	input {
		min-width: 100px;
	}
`;
